import React, { useEffect, useState } from "react";
import "../../CSS/ItemMaster.css";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import "jspdf-autotable";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";

const ErrorCorrections = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);
  const [search, setSearch] = useState("");
  const state = useSelector((state) => state.changeTheState.user);
  const user = state.emailId?.split("@")[0]?.toUpperCase();
  const [vehiclesList, setVehiclesList] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selState, setSelState] = useState("");

  const [driversList,setDriversList] = useState([])
  const [loadingAdviceData, setLoadingAdviceData] = useState([]);
  const [returnsData, setReturnsData] = useState([]);
  const [wbData, setWBData] = useState([]);
  const [workshopData, setWorkShopData] = useState([]);
  const [gateOutData, setGateOutData] = useState([]);

  const filteredData = tableData.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0 && !selState) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "DEPARTMENT",
        "MAKE",
        "VEHICLE REG NO",
        "DRIVERNAME",
        "VEHICLESTATE",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    const stateFilter = !selState || item?.VEHICLESTATE === selState;

    return textMatch && stateFilter;
  });

  useEffect(() => {
    initialData();
  }, []);

  useEffect(() => {
    if (vehiclesList?.length) {
      setTableData(
        vehiclesList.map((item) => ({
          DEPARTMENT: item.DEPARTMENT,
          MAKE: item.MAKE,
          ["VEHICLE REG NO"]: item?.["VEHICLE REG NO"],
          DRIVERNAME: item.DRIVERNAME,
          VEHICLESTATE: item.VEHICLESTATE,
          proceedTo: "",
          driverName:"",
        })),
      );
    }
  }, [vehiclesList]);

  const initialData = () => {

     // Driver's List  345;
        axios
          .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=345`, {
            headers: {
              "auth-token": authToken,
              "session-token": sessionToken,
            },
          })
          .then((response) => {
            setDriversList(response?.data);
          })
          .catch((error) => {
            setisloading(false);
            console.error("Error fetching Driver details:", error);
          });


    // Loading Advice Data
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1095`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setLoadingAdviceData(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details 1095:", error);
      });

    // Returns Data
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1078`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setReturnsData(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching 1078 details:", error);
      });

    // Weighbridge Data
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1228`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filter = response?.data?.filter(
          (item) => item?.SECONDWEIGHT === null,
        );
        setWBData(filter);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Weigh in details:", error);
      });

    // Workshop Data
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1081`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setWorkShopData(response.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching 1081 details:", error);
      });

    // Gate Out data
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1092`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setGateOutData(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching 1092 details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setVehiclesList(response?.data);
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details 671:", error);
      });
  };

  const updateTableField = (vehicle, field, value) => {
    setVehiclesList((prev) =>
      prev.map((row) =>
        String(row?.["VEHICLE REG NO"]) === String(vehicle)
          ? { ...row, [field]: value }
          : row,
      ),
    );
  };

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen">
      <AllPagesNavbar />
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          LOGISTICS ERROR CORRECTIONS
        </h1>
      </div>

      <div className="select_product_type" style={{ marginTop: "5px" }}>
        <div>
          <p>Search</p>
        </div>
        <div>
          <input
            type="text"
            className="w-64 h-8 border border-black rounded-md"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></input>
        </div>
        <div>
          <p>State :</p>
        </div>
        <div>
          <Select
            className="lg:w-64 w-64 lg:ml-2"
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (base) => ({ ...base, zIndex: 9999 }),
            }}
            value={
              selState
                ? { value: selState, label: selState }
                : { value: "", label: "Select State" }
            }
            onChange={(e) => {
              setSelState(e.value);
            }}
            options={[
              { value: "", label: "Select Proceed To" },
              {
                value: "SENT TO WORKSHOP",
                label: "SENT TO WORKSHOP",
              },
              { value: "SENT TO LOAD", label: "SENT TO LOAD" },
              {
                value: "SENT FOR RETURNS",
                label: "SENT FOR RETURNS",
              },
              {
                value: "SENT FOR WEIGHBRIDGE",
                label: "SENT FOR WEIGHBRIDGE",
              },
              {
                value: "DISPATCHED",
                label: "DISPATCHED",
              },
              {
                value: "GATE OUT",
                label: "GATE OUT",
              },
              {
                value: "JOB IN WORKSHOP",
                label: "JOB IN WORKSHOP",
              },
            ]}
          ></Select>
        </div>
      </div>

      <div className="visible lg:h-[500px] p-1 z-0 lg:overflow-auto mt-2">
        <table className="w-full border border-gray-300 text-sm">
          <thead className="sticky top-0">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-right border border-gray-300">
                SNO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                DEPARTMENT
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MAKE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                VEHICLE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                DRIVER
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                CURRENT STATE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                PROCEED TO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                ACTION
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                CHANGE DRIVER
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((value, index) => (
              <tr
                key={index}
                className="hover:bg-gray-100 cursor-pointer text-[13px]"
                // onClick={() => handleRowClick(value, index)}
              >
                <td className="py-2 px-4 text-right border border-gray-300">
                  {index + 1}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.DEPARTMENT || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.MAKE || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value?.["VEHICLE REG NO"] || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.DRIVERNAME || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.VEHICLESTATE || "N/A"}
                </td>
                <td className="py-2 px-1 text-left border border-gray-300">
                  <Select
                    className="lg:w-64"
                    value={
                      vehiclesList.find(
                        (r) =>
                          r?.["VEHICLE REG NO"] === value?.["VEHICLE REG NO"],
                      )?.proceedTo
                        ? {
                            value: vehiclesList.find(
                              (r) =>
                                r?.["VEHICLE REG NO"] ===
                                value?.["VEHICLE REG NO"],
                            ).proceedTo,
                            label: vehiclesList.find(
                              (r) =>
                                r?.["VEHICLE REG NO"] ===
                                value?.["VEHICLE REG NO"],
                            ).proceedTo,
                          }
                        : { value: "", label: "Select Proceed To" }
                    }
                    onChange={(e) => {
                      if (e.label === "PROCEED TO WORKSHOP") {
                        const isLoadingAdviced = workshopData?.find(
                          (item) =>
                            item?.OT_JOB_VEHICLE === value?.["VEHICLE REG NO"],
                        );
                        if (isLoadingAdviced) {
                          alert(
                            "This Vehicle is already processed in Workshop",
                          );
                          return;
                        } else {
                          updateTableField(
                            value?.["VEHICLE REG NO"],
                            "proceedTo",
                            e.label,
                          );
                        }
                      } else if (e.label === "PROCEED TO LOAD") {
                        const isLoadingAdviced = loadingAdviceData?.find(
                          (item) =>
                            item?.OT_LOADING_ADVISE_VEHICLE_NO ===
                            value?.["VEHICLE REG NO"],
                        );
                        if (isLoadingAdviced) {
                          alert("This Vehicle is already processed to Load");
                          return;
                        } else {
                          updateTableField(
                            value?.["VEHICLE REG NO"],
                            "proceedTo",
                            e.label,
                          );
                        }
                      } else if (e.label === "PROCEED TO RETURNS") {
                        const isLoadingAdviced = returnsData?.find(
                          (item) =>
                            item?.OT_RETURN_TRUCK_NUMBER ===
                            value?.["VEHICLE REG NO"],
                        );
                        if (isLoadingAdviced) {
                          alert("This Vehicle is already processed to Return");
                          return;
                        } else {
                          updateTableField(
                            value?.["VEHICLE REG NO"],
                            "proceedTo",
                            e.label,
                          );
                        }
                      } else if (e.label === "PROCEED TO WEIGHBRIDGE") {
                        const isLoadingAdviced = wbData?.find(
                          (item) =>
                            item?.OT_DISPATCH_VEHICLE_REG_NO ===
                            value?.["VEHICLE REG NO"],
                        );
                        if (isLoadingAdviced) {
                          alert(
                            "This Vehicle is already processed to WeighBridge",
                          );
                          return;
                        } else {
                          updateTableField(
                            value?.["VEHICLE REG NO"],
                            "proceedTo",
                            e.label,
                          );
                        }
                      } else if (e.label === "PROCEED TO GATE OUT") {
                        const isLoadingAdviced = gateOutData?.find(
                          (item) =>
                            item?.OT_GATE_OUT_VEHICLE_REG_NO ===
                            value?.["VEHICLE REG NO"],
                        );
                        if (isLoadingAdviced) {
                          alert(
                            "This Vehicle is already processed to Gate Out",
                          );
                          return;
                        } else {
                          updateTableField(
                            value?.["VEHICLE REG NO"],
                            "proceedTo",
                            e.label,
                          );
                        }
                      } else {
                        updateTableField(
                          value?.["VEHICLE REG NO"],
                          "proceedTo",
                          e.label,
                        );
                      }
                    }}
                    options={[
                      { value: "", label: "Select Proceed To" },
                      {
                        value: "SENT TO WORKSHOP",
                        label: "PROCEED TO WORKSHOP",
                      },
                      { value: "SENT TO LOAD", label: "PROCEED TO LOAD" },
                      {
                        value: "SENT FOR RETURNS",
                        label: "PROCEED TO RETURNS",
                      },
                      {
                        value: "SENT FOR WEIGHBRIDGE",
                        label: "PROCEED TO WEIGHBRIDGE",
                      },
                      {
                        value: "DISPATCHED",
                        label: "PROCEED TO GATE OUT",
                      },
                    ]}
                  />
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  <button className="border border-black bg-[#002d62] text-white rounded-md px-3  lg:ml-1 mr-1 h-10 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300">
                    Change Status
                  </button>
                </td>

                <td className="py-2 px-1 text-left border border-gray-300">
                  <Select
                    className="lg:w-64"
                    value={
                      vehiclesList.find(
                        (r) =>
                          r?.["VEHICLE REG NO"] === value?.["VEHICLE REG NO"],
                      )?.driverName
                        ? {
                            value: vehiclesList.find(
                              (r) =>
                                r?.["VEHICLE REG NO"] ===
                                value?.["VEHICLE REG NO"],
                            ).driverName,
                            label: vehiclesList.find(
                              (r) =>
                                r?.["VEHICLE REG NO"] ===
                                value?.["VEHICLE REG NO"],
                            ).driverName,
                          }
                        : { value: "", label: "Select Driver" }
                    }
                    onChange={(e) => {
                      updateTableField(
                        value?.["VEHICLE REG NO"],
                        "driverName",
                        e.label,
                      );
                    }}
                    options={[
                      { value: "", label: "Select Driver" },
                      ...driversList?.map((item) => ({
                        value: item.DRIVERCODE,
                        label: item.DRIVERNAME,
                      })),
                    ]}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ErrorCorrections;
